import { isFailedAndReport, isFailedCreateOrEditAndReport, isFailedListAndReport } from "@/api/helper"
import { IDataWrapper } from "@/api/types"
import { E_DialogStage } from "@/utils/dialog"
import { getCurrentInstance } from "vue"
import { LocaleMessages } from "vue-i18n"

/**
 * 通用报告hook 
 */
export function useReport() {
    const instance = getCurrentInstance()
    const h = instance.proxy.$createElement

    return {
        /**
         * 测试数据是否有问题并且报告         
         */
        isFailedListAndReport<T>(res: IDataWrapper<T>, checkData = false) {
            return isFailedListAndReport(instance.proxy, res, checkData)
        },
        /**
         * 测试数据是否有问题并且报告         
         */
        isFailedAndReport<T>(res: IDataWrapper<T>) {
            return isFailedAndReport(instance.proxy, res)
        },
        /**
         * 报告创建、编辑结果，成功和失败都会显示消息。
         * 返回 true 表示失败；成功后无需再次调用 showSuccessMessage。
         */
        isFailedCreateOrEditAndReport<T>(res: IDataWrapper<T>, stage: E_DialogStage) {
            return isFailedCreateOrEditAndReport(instance.proxy, res, stage)
        },
        /**
         * 成功提示
         */
        showSuccessMessage(message: string | LocaleMessages) {
            return instance.proxy.$message({
                type: 'success',
                message: message as string,
                offset: 60,
            })
        },
        /**
         * 警告提示
         */
        showWarningMessage(message: string | LocaleMessages) {
            return instance.proxy.$message({
                type: 'warning',
                message: message as string,
                offset: 60,
            })
        },
        /**
         * 错误提示
         */
        showErrorMessage(message: string | LocaleMessages) {
            return instance.proxy.$message({
                type: 'error',
                message: message as string,
                offset: 60,
            })
        },
        /**
         * 
         * 错误提示 2
         */
        showVNodeErrorMessage(messageFn) {
            let vnode = messageFn(h)
            return instance.proxy.$message({
                type: 'error',
                message: vnode,
                offset: 60,
            })
        }
    }
}
